"use client";

import { ListingsGridCard } from "@/components";
import type { Listing } from "@/services/api";

interface BestDealsSectionProps {
    bestDeals: Listing[];
    isDealsFetching: boolean;
}

const BestDealsSection: React.FC<BestDealsSectionProps> = ({
    bestDeals,
    isDealsFetching,
}) => {
    return (
        <div className="px-4 pb-6">
            <h2 className="text-lg md:text-xl font-raleway font-semibold text-black mb-6">
                Best Deals at the moment
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2">
                {bestDeals.map((listing) => (
                    <ListingsGridCard
                        key={listing._id}
                        listing={listing}
                        showDealLabel={true}
                    />
                ))}
            </div>

            {isDealsFetching && (
                <div className="flex justify-center items-center py-12">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
                </div>
            )}
        </div>
    );
};

export default BestDealsSection; 